import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { ReduceStore } from 'flux/utils';

const getEmptyState = (isFetching = false) => ({isFetching, attributes: []});

class AttributeStore extends ReduceStore {

    getInitialState() {
        return getEmptyState();
    }

    isFetching() {
        return this.getState().isFetching;
    }

    getAll() {
        const { attributes } = this.getState();
        const sortMap = attributes
            .map(({code, listOrder}, index) => ({index, code, listOrder: Number(listOrder) || 10000}))
            .sort((a, b) => ((a.listOrder - b.listOrder ) || a.code.localeCompare(b.code)));
        return sortMap.map(({index}) => attributes[index]);
    }

    getUserEditable() {
        return this.getState().attributes.filter((a) => a !== undefined && !!a.isUserEditable && !!a.isActive)
    }

    reduce(state, action) {
        switch(action.type) {
            case ActionTypes.ATTRIBUTE_LIST_REQUEST:
                return {...state, isFetching: true};

            case ActionTypes.ATTRIBUTE_LIST_SUCCESS:
                return {isFetching: false, attributes: action.data};

            case ActionTypes.ATTRIBUTE_LIST_FAILURE:
                return getEmptyState();

            case ActionTypes.ATTRIBUTE_ACTIVE_LIST_REQUEST:
                return {...state, isFetching: true};

            case ActionTypes.ATTRIBUTE_ACTIVE_LIST_SUCCESS:
                return {isFetching: false, attributes: action.data};

            case ActionTypes.ATTRIBUTE_ACTIVE_LIST_FAILURE:
                return getEmptyState();

            case ActionTypes.ATTRIBUTE_SET_ACTIVE_REQUEST:
            case ActionTypes.ATTRIBUTE_SET_ACTIVE_SUCCESS:
            case ActionTypes.ATTRIBUTE_SET_ACTIVE_FAILURE:
            case ActionTypes.ATTRIBUTE_SET_REQUIRED_REQUEST:
            case ActionTypes.ATTRIBUTE_SET_REQUIRED_SUCCESS:
            case ActionTypes.ATTRIBUTE_SET_REQUIRED_FAILURE:
                
            default:
                return state;
        }
    }
}

export default new AttributeStore(CentricDispatcher);
